var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContribute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6168 20.7833C32.3043 20.7833 36.1042 16.9837 36.1042 12.2968C36.1042 7.60988 32.3043 3.81036 27.6168 3.81036C22.9294 3.81036 19.1295 7.60988 19.1295 12.2968C19.1295 16.9837 22.9294 20.7833 27.6168 20.7833Z",
    fill: "url(#paint0_linear_239_1659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6168 24.3167C18.9252 24.3167 11.8779 31.3632 11.8779 40.0539C11.8779 42.3312 13.7266 44.1797 16.0041 44.1797H39.2294C41.507 44.1797 43.3658 42.3312 43.3658 40.0539C43.3658 31.3632 36.3186 24.3167 27.6168 24.3167Z",
    fill: "url(#paint1_linear_239_1659)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_239_1659)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_1659)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_239_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1275 20.9346C24.5964 19.5199 27.0723 14.7507 25.6577 10.2823C24.2432 5.81396 19.4737 3.3385 15.0049 4.75323C10.536 6.16796 8.06007 10.9371 9.47466 15.4055C10.8892 19.8739 15.6587 22.3494 20.1275 20.9346Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1275 20.9346C24.5964 19.5199 27.0723 14.7507 25.6577 10.2823C24.2432 5.81396 19.4737 3.3385 15.0049 4.75323C10.536 6.16796 8.06007 10.9371 9.47466 15.4055C10.8892 19.8739 15.6587 22.3494 20.1275 20.9346Z",
    stroke: "url(#paint2_linear_239_1659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4348 15.5878C19.9504 15.108 20.7901 13.4906 20.3104 11.9752C19.8306 10.4598 18.2131 9.62025 16.6975 10.1C15.182 10.5798 14.3423 12.1973 14.822 13.7127C15.3018 15.2281 16.9193 16.0676 18.4348 15.5878Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4348 15.5878C19.9504 15.108 20.7901 13.4906 20.3104 11.9752C19.8306 10.4598 18.2131 9.62025 16.6975 10.1C15.182 10.5798 14.3423 12.1973 14.822 13.7127C15.3018 15.2281 16.9193 16.0676 18.4348 15.5878Z",
    stroke: "url(#paint3_linear_239_1659)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_239_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.194 24.3033C12.9078 26.9266 8.31588 35.7714 10.9388 44.0568C11.6262 46.228 13.9465 47.4323 16.1179 46.7449L38.26 39.7352C40.4314 39.0478 41.6457 36.7245 40.9584 34.5534C38.3354 26.268 29.4901 21.677 21.194 24.3033Z",
    fill: "white",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("line", {
    x1: 1.13341,
    y1: -1.13341,
    x2: 11.8672,
    y2: -1.13341,
    transform: "matrix(0.944497 -0.328519 0.374099 0.927389 18.0568 37.5397)",
    stroke: "url(#paint4_linear_239_1659)",
    strokeWidth: 2.26683,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_239_1659",
    x: -7.1405,
    y: -7.14053,
    width: 56.4876,
    height: 62.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.57025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_239_1659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_239_1659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_239_1659",
    x: -5.92334,
    y: -10.6449,
    width: 46.9791,
    height: 46.9776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_239_1659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_239_1659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_239_1659",
    x: -4.79901,
    y: 8.56378,
    width: 60.9497,
    height: 53.3744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_239_1659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_239_1659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_1659",
    x1: 28.8665,
    y1: 13.4334,
    x2: 13.9516,
    y2: 20.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_1659",
    x1: 29.94,
    y1: 35.5783,
    x2: 8.48031,
    y2: 52.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_1659",
    x1: 10.0862,
    y1: 8.38445,
    x2: 24.4555,
    y2: 17.9019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_1659",
    x1: 15.0294,
    y1: 11.3315,
    x2: 19.9026,
    y2: 14.5593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_1659",
    x1: -1.44856,
    y1: 0,
    x2: 14.785,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4879,
    height: 40.3796,
    fill: "white",
    transform: "translate(11.8779 3.8103)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4879,
    height: 40.3796,
    fill: "white",
    transform: "translate(0 9.50345) rotate(-17.5666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContribute);
export default __webpack_public_path__ + "static/media/contribute.3033f59e08cdd975dc926ab995803f34.svg";
export { ForwardRef as ReactComponent };